module.exports = __webpack_public_path__ + "media/images/element/artist-84031cb2eb22aad0ddf23b383d0a762f.svg";